// extracted by mini-css-extract-plugin
export default {"very_bad":"styles_very_bad__dE6Sd","bad":"styles_bad__Vypjt","neutral":"styles_neutral__Ln2XO","good":"styles_good__3SCVn","very_good":"styles_very_good__XY2la"};